"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpForm = void 0;
const _ = __importStar(require("lodash"));
const debug_1 = __importDefault(require("debug"));
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const core_1 = require("@integro/core");
const validation_1 = require("../../validation");
const form_html_1 = __importDefault(require("./form.html"));
const log = (0, debug_1.default)('itp:ui:form');
let ItpForm = class ItpForm extends vue_1.default {
    $refs;
    form;
    componentContext;
    id;
    name;
    schema;
    autocomplete;
    autofocus;
    disabled;
    readonly;
    row;
    labelAlign;
    data() {
        return {
            form: null
        };
    }
    onDisabledChanged() {
        if (this.form) {
            this.form.disabled = this.disabled;
        }
    }
    onReadonlyChanged() {
        if (this.form) {
            this.form.readonly = this.readonly;
        }
    }
    onFormSubmitted(event, slotProps) {
        log('onFormSubmitted (id=%s, name=%s) event=%o', this.id, this.name, event);
        slotProps.handleSubmit(this.submit);
    }
    get formClass() {
        return;
    }
    get fieldsetClass() {
        return this.row ? 'row' : null;
    }
    submit() {
        log("FORM submit called.");
        this.$emit('submit', { validationObserver: this.$refs.observer });
    }
    mounted() {
        this.form = new validation_1.ObservedForm(this.id, this.name, this.$refs.observer, this.componentContext, this.disabled, this.readonly, this.$el);
        this.$watch(() => this.$refs.observer.flags, flags => {
            log("Observer has changed, updating flags from FORM. flags=%o", flags);
            this.form.updateFlags(flags);
        });
        this.form.validate({ silent: true });
        if (this.autofocus === 'first') {
            this.$nextTick(() => this.autofocusFirstElement());
        }
        this.$nextTick(() => this.form.reset());
    }
    autofocusFirstElement() {
        const children = findChildInputsRecursive(this.$el);
        if (children && children.length) {
            const fn = _.get(children[0], 'focus');
            if (_.isFunction(fn)) {
                fn.call(children[0]);
            }
        }
    }
    beforeUnmount() {
        this.componentContext.unregisterForm(this.form);
    }
};
exports.ItpForm = ItpForm;
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: () => (0, core_1.uniqueID)() }),
    __metadata("design:type", String)
], ItpForm.prototype, "id", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", String)
], ItpForm.prototype, "name", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], ItpForm.prototype, "schema", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'off' }),
    __metadata("design:type", String)
], ItpForm.prototype, "autocomplete", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'off' }),
    __metadata("design:type", Object)
], ItpForm.prototype, "autofocus", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false }),
    __metadata("design:type", Boolean)
], ItpForm.prototype, "disabled", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false }),
    __metadata("design:type", Boolean)
], ItpForm.prototype, "readonly", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false }),
    __metadata("design:type", Boolean)
], ItpForm.prototype, "row", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpForm.prototype, "labelAlign", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('disabled'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ItpForm.prototype, "onDisabledChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('readonly'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ItpForm.prototype, "onReadonlyChanged", null);
exports.ItpForm = ItpForm = __decorate([
    (0, vue_property_decorator_1.Component)({
        template: form_html_1.default,
        inject: {
            componentContext: 'componentContext',
        },
        provide() {
            return { formContext: this };
        }
    })
], ItpForm);
function findChildInputsRecursive(element, result) {
    if (!result) {
        result = [];
    }
    if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA' || element.tagName === 'SELECT' || element.tagName === 'CHECKBOX') {
        result.push(element);
    }
    const children = element.children;
    for (let i = 0; i < children.length; i++) {
        findChildInputsRecursive(children[i], result);
    }
    return result;
}
//# sourceMappingURL=form.js.map